import { all } from "redux-saga/effects";
import Auth from "./Auth";
import UsersAndTeam from "./UsersAndTeam";
import channel from "./channel";
import inbox from "./inbox";
import campaign from "./Campaign";
import contacts from "./contacts";
import botFlow from "./BotFlow";
import faas from "./Faas";
import dashboard from "./dashboard";
import chatAssignment from "./ChatAssignment";
import bot from "./Bot";
import Schedule from "./Schedule";
import common from "./common";
import emailAssignment from "./EmailAssignment";
import tickets from "./tickets";
import MarketPlace from "./MarketPlace";

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    UsersAndTeam(),
    channel(),
    inbox(),
    campaign(),
    contacts(),
    botFlow(),
    faas(),
    dashboard(),
    chatAssignment(),
    bot(),
    Schedule(),
    common(),
    emailAssignment(),
    tickets(),
    MarketPlace(),
  ]);
}
